import { WashStation } from "./stations.types";

export interface ScheduleSetting {
  id: string;
  name: string;
  hour: string;
  isAllowed: boolean;
  station: WashStation;
}

export enum WEEK_DAYS {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  HOLIDAY = "HOLIDAY"
}

export type WeekdayT = {
  enum: WEEK_DAYS,
  nameBr: string;
}

export type FullSchedule = {
  [key in WEEK_DAYS]: ScheduleSetting[];
};

